import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '24px' }}>
      <p style={{ color: 'var(--gold)', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: 16 }}>Erreur 404</p>
      <h1 style={{ fontFamily: 'Oswald, sans-serif', fontSize: 'clamp(3rem, 8vw, 6rem)', fontWeight: 900, color: 'var(--white)', textTransform: 'uppercase', lineHeight: 1, marginBottom: 24 }}>
        Page<br /><span style={{ color: 'var(--gold)' }}>introuvable</span>
      </h1>
      <p style={{ color: 'var(--gray)', fontSize: '1rem', lineHeight: 1.7, maxWidth: 400, marginBottom: 40 }}>
        Cette page n'existe pas ou a été déplacée. Retournez à l'accueil pour continuer.
      </p>
      <Link to="/" className="btn btn-primary">Retour à l'accueil</Link>
    </div>
  );
}

export default NotFound;
